<template>
  <div v-show="this.form.salesType==2" class="rj-col-3">
    <div class="rj-baseinfo">
      <div class="rj-baseinfo__label">
        账期：
      </div>
      <div class="rj-baseinfo__item force-line-break">
        {{ form.accountPeriod }}
        <el-popover v-model="showPeriodTotal"
                    placement="right"
                    width="400" trigger="click"
        >
          <multi-account v-if="showPeriodTotal" v-model="form.accountPeriod" @change="showPeriodTotal=false" />
          <el-button v-if="showChangeButton()" slot="reference" type="text" style="padding: 0 10px">
            更改
          </el-button>
        </el-popover>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import MultiAccount from './MultiAccount';
export default {
  data () {
    return {
      showPeriodTotal: false
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {
    MultiAccount
  },
  computed: {},
  methods: {
    showChangeButton () {
      if (this.form.extContractData != null) {
        if (this.form.extContractData.frameworkAgreementCode) {
          return false;
        } else {
          return true;
        }
      }
      return true;
    }
  },
  mounted () {
  }
};
</script>
<style lang="scss" scope>
.force-line-break{
  overflow: hidden;
  overflow-wrap: break-word;
  word-wrap: break-word;
}
</style>
